import { UI, HStack as NBHStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import * as React from 'react';

export declare namespace SubItemProductTypes {
  interface Props {
    name: string;
    percentage: number;
    value: number;
  }
}

export const SubItemProduct = ({ name, percentage, value }: SubItemProductTypes.Props) => {
  return (
    <NBHStack justifyContent="space-between">
      <NBHStack space={Spacing['inline.nano']}>
        <UI.Text fontSize={Typography['fontsize.xs']} variant="semibold" color="neutral.dark">
          {`${percentage}%`}
        </UI.Text>
        <UI.Text fontSize={Typography['fontsize.xs']} variant="semibold" color="neutral.dark">
          {name}
        </UI.Text>
      </NBHStack>
      <UI.Text fontSize={Typography['fontsize.xs']} variant="semibold">
        {Utils.Mask.Money(value)}
      </UI.Text>
    </NBHStack>
  );
};
